import { CommandParser } from '@redis/client/dist/lib/client/parser';
import { RedisArgument, ArrayReply, BlobStringReply, NullReply, Command } from '@redis/client/dist/lib/RESP/types';

export interface JsonObjKeysOptions {
  path?: RedisArgument;
}

export default {
  parseCommand(parser: CommandParser, key: RedisArgument, options?: JsonObjKeysOptions) {
    parser.push('JSON.OBJKEYS');
    parser.pushKey(key);
    if (options?.path !== undefined) {
      parser.push(options.path);
    }
  },
  transformReply: undefined as unknown as () => ArrayReply<BlobStringReply> | ArrayReply<ArrayReply<BlobStringReply> | NullReply>
} as const satisfies Command;
